import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import collaborationApi from "../api/collaborationApi";
import companyApi from "../api/company";
import usersApi from "../api/userApi";

const AdminDashboard = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [totalCollabs, setTotalCollabs] = useState(0);
  // Function to fetch user count from API
  const fetchTotalUsers = async () => {
    try {
      const count = await usersApi.usersCount();
      setTotalUsers(count); // update state with API response
    } catch (error) {
      console.error("Failed to fetch user count:", error);
      setTotalUsers(0); // fallback
    }
  };

  const fetchTotalCompanies = async () => {
    try {
      const count = await companyApi.companyCount();
      setTotalCompanies(count); // update state with API response
    } catch (error) {
      console.error("Failed to fetch company count:", error);
      setTotalCompanies(0); // fallback
    }
  };
  const fetchTotalCollabs = async () => {
    try {
      const count = await collaborationApi.collabCount();
      setTotalCollabs(count); // update state with API response
    } catch (error) {
      console.error("Failed to fetch collaboration count:", error);
      setTotalCollabs(0); // fallback
    }
  }

  useEffect(() => {
    fetchTotalUsers();
    fetchTotalCompanies();
    fetchTotalCollabs();
  }, []);

  const handleComingSoon = () => {
    Swal.fire({
      icon: "info",
      title: "Coming Soon!",
      text: "This feature is under development.",
      confirmButtonText: "OK",
    });
  };
  return (
    <>
      <h1>
        <strong>Admin Dashboard</strong>
      </h1>
      <Row className="mt-4">
        <Col md={4}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Total Users</Card.Title>
              <Card.Text style={{ fontSize: "2rem" }}>{totalUsers}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Total Companies</Card.Title>
              <Card.Text style={{ fontSize: "2rem" }}>{totalCompanies}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center" onClick={handleComingSoon}>
            <Card.Body>
              <Card.Title>Total Collaborations</Card.Title>
              <Card.Text style={{ fontSize: "2rem" }}>{totalCollabs}</Card.Text>
              {/* <OverlayTrigger
                placement="top"
                overlay={renderTooltip("Functionality coming soon")}
              >
                <span>
                  <Button variant="primary" disabled>Accept Companies</Button>
                </span>
              </OverlayTrigger> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <Row className="mt-5">
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title>Recent User Registrations</Card.Title>
              <ul>
                <li>Rehana - rehana@gmail.com</li>
                <li>Shubhadip Raj - shubhadip@gamil.com</li>
                <li>Jay kuamr - jai@gamil.com</li>
                <li>Ambika - ambika@gamil.com</li>
                <li>Sintu kumar - sintu@gamil.com</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title>Admin Actions</Card.Title>
              <ul>
                <li>
                  Manage Users <span className="text-muted">(Coming Soon)</span>
                </li>
                <li>
                  Manage Documents{" "}
                  <span className="text-muted">(Coming Soon)</span>
                </li>
                <li>
                  Credit Settings{" "}
                  <span className="text-muted">(Coming Soon)</span>
                </li>
                <li>
                  Company Verification{" "}
                  <span className="text-muted">(Coming Soon)</span>
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
    </>
  );
};

export default AdminDashboard;
